import React from "react";

const OrderPaymentDetail = ({ trackData }) => {
  return (
    <div className="row justify-content-between h-100 mt-lg-0 mt-md-0 mt-4">
      <div className="row">
        <div className="col-md-4 col-lg-4 col-6">
          <h6 className="fw-bold">Payment</h6>
          <p className="mb-1">{trackData?.payment_method}</p>
          {/* <img
            className="w-50 h-auto rounded-lg"
            src="https://samarapotolki.ru/img/sposoby-oplaty/visa-ico.jpg"
            alt="Visa Logo"
          /> */}
        </div>
        <div className="col-md-8 col-md-8 col-6">
          <div style={{ width: "fit-content" }} className="ms-auto">
            <h6 className="fw-bold">Delivery</h6>
            <p className="mb-1">{trackData?.street_address}</p>
            <p className="mb-0">{trackData?.state}</p>
            <p className="mb-1">{trackData?.phone}</p>
          </div>
        </div>
      </div>
      <div className="row mt-3">
        {/* <div className="col-md-4 col-lg-4 col-6">
          <h6 className="fw-bold">Need Help</h6>
          <ul className="list-unstyled">
            <li>
              <button className="bg-transparent mt-2 text-secondary">
                Order Issues →
              </button>
            </li>
            <li>
              <button className="bg-transparent mt-2 text-secondary">
                Delivery Info →
              </button>
            </li>
            <li>
              <button className="bg-transparent mt-2 text-secondary">
                Returns →
              </button>
            </li>
          </ul>
        </div> */}
        <div className="col-12">
          <h6 className="fw-bold">Order Summary</h6>
          <div className="d-flex justify-content-between">
            <p className="mb-1">Subtotal</p>
            <p className="mb-1">${trackData?.sub_total}</p>
          </div>
          <div className="d-flex justify-content-between">
            <p className="mb-1">Discount</p>
            <p className="mb-1">- ${trackData?.discount_price}</p>
          </div>

          {/* <div className="d-flex justify-content-between">
            <p className="mb-1">Tax</p>
            <p className="mb-1">+ $5</p>
          </div> */}
          <hr className="my-2" />
          <div className="d-flex justify-content-between fw-bold">
            <p className="mb-0">Total</p>
            <p className="mb-0">${trackData?.total_price}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderPaymentDetail;
